module.exports = __webpack_public_path__ + "leadingMiddle.2qZB6sn5.svg";